/*
Used to add another product to the cart as an upsell.
*/
if (!customElements.get('cartitem-upsell')) {
  customElements.define(
    'cartitem-upsell',
    class CartItemUpsell extends HTMLElement {
      constructor() {
        super();

        this.querySelector('button').addEventListener('click', this.handleUpsell.bind(this));
      }

      async handleUpsell() {
        const productId = this.dataset.productId;
        const variantId = this.dataset.variantId;
        const quantity = this.dataset.quantity;
        const index = this.dataset.index;

        this.toggleLoading();

        this.addItemToCart(variantId, quantity, index);

        if (typeof gtag !== 'undefined') {
          gtag('event', 'cart_upsell', {
            event_category: 'upsell',
            event_label: 'Cart Upsell',
            product_id: productId,
            variant_id: variantId,
            quantity: quantity,
          });
        }
      }

      toggleLoading() {
        this.classList.toggle('loading');
      }

      handleError(message = 'Oops! There was an error making this change.') {
        this.classList.add('alert', 'alert--error');
        this.innerHTML = message;
      }

      addItemToCart(variantId, quantity, index) {
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

        const body = JSON.stringify({
          id: variantId,
          quantity,
          sections: cartItems.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            // Update cart sections similar to how CartItems.updateQuantity does it
            cartItems.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              );
            });

            // Dispatch custom event for cart updates
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cartData: parsedState, source: 'cart-item-upsell', variantId },
              }),
            );

            // Publish cart update event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-item-upsell', cartData: parsedState, variantId: variantId });
            }

            this.remove();
          })
          .catch((error) => {
            console.error('Error addItemToCart:', error);
            this.toggleLoading();
            this.handleError();
          });
      }
    }
  );
}
